import React from 'react';
import { DISPLAY_DATE_FORMAT, PIPELINE_DISPLAY_DATE_FORMAT} from "../utils/constant";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faPlusCircle, faAsterisk } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { connect } from "react-redux";
import Load from '../components/loadAction';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Dropdown from 'react-bootstrap/Dropdown';
import Image from '../components/image';
import Form from 'react-bootstrap/Form';
import { Button } from "react-bootstrap";
import $ from 'jquery';
import { faAngleDoubleDown} from "@fortawesome/free-solid-svg-icons";
import { getApi } from "../utils/event_handling";
import QualdoDataTable from "../components/bootstrapTable";
import PipelinePerformFullScreen from "./pipelinePerformFullScreen";
import Popover from 'react-bootstrap/Popover';
import { browserHistory} from 'react-router';
import * as ReactDOM from 'react-dom';
import {call_get_api} from "../utils/event_handling";
import {  ui_service_ip } from "../utils/ip_details";
import RcTooltip from 'rc-tooltip';
import Select, {
    components,
} from 'react-select';
// import { timeHours } from 'd3';
// import PipelineLineage from "./pipelineLineage";

let pipeline_page_cnt = 50;
let pipeline_first_click_page_cnt = 50;
let pipeline_second_click_page_page_cnt = 100;

const customSelectDatasource = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24"  className="form-control__icon" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><path d="M15,22h4c1.1,0,2-0.9,2-2v-3c0-1.1-0.9-2-2-2h-1v-2c0-1.1-0.9-2-2-2h-3V9h1c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2h-4 C8.9,2,8,2.9,8,4v3c0,1.1,0.9,2,2,2h1v2H8c-1.1,0-2,0.9-2,2v2H5c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-3 c0-1.1-0.9-2-2-2H8v-2h8v2h-1c-1.1,0-2,0.9-2,2v3C13,21.1,13.9,22,15,22" /></g></svg>
        {children}
    </components.Control>

);

class PipelineListViewContent extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.setFullScreen = this.setFullScreen.bind(this);
        this.gotoRuns = this.gotoRuns.bind(this)
        this.getGanttPopover = this.getGanttPopover.bind(this);
        this.changePipelineSource = this.changePipelineSource.bind(this);
        this.closeFullScreenMode = this.closeFullScreenMode.bind(this);
        this.handlePipelineListViewTimeFilter = this.handlePipelineListViewTimeFilter.bind(this);
        this.renderJobsSourceHtml = this.renderJobsSourceHtml.bind(this);
        this.applyTablewrapperClasses = this.applyTablewrapperClasses.bind(this);
        this.searchResult = this.searchResult.bind(this)
        this.toggleFilter = this.toggleFilter.bind(this)
        this.handleClearAll = this.handleClearAll.bind(this)

        let startDate = moment().utc(); //moment().subtract(9, 'days').set({ "hour": 0, "minute": 0, "seconds": 0 });
        let endDate = moment().utc();
        this.getData = this.getData.bind(this);
        // TimeFilter
        this.getApi = getApi.bind(this);
        this.filterData = this.filterData.bind(this);
        this.paging = this.paging.bind(this);
        this.pagingreset = this.pagingreset.bind(this);
        this.activeRun = this.activeRun.bind(this);
        this.pipelineSourceTableData = this.pipelineSourceTableData.bind(this);
        this.handlePipelineTreeTriger = this.handlePipelineTreeTriger.bind(this);
        this.errMessage = this.errMessage.bind(this); 
        this.pipelinesourceFilterSelection = this.pipelinesourceFilterSelection.bind(this); 
        this.innerpage = this.innerpage.bind(this); 
        this.pageTrack = this.pageTrack.bind(this); 
        this.prevDate = this.prevDate.bind(this);
        this.nextDate = this.nextDate.bind(this);
        this.nowDate = this.nowDate.bind(this);
        this.applyTimeFilter = this.applyTimeFilter.bind(this)
        this.timeFilterRenderHtml = this.timeFilterRenderHtml.bind(this);
        this.applyTimeFilterNow = this.applyTimeFilterNow.bind(this);
        this.datewisejobsdata = this.datewisejobsdata.bind(this);
        this.renderPipelineSourceHtml = this.renderPipelineSourceHtml.bind(this);
        this.gotoPipelineConfigure = this.gotoPipelineConfigure.bind(this);
        this.resetRunView = this.resetRunView.bind(this);
        let listViewTableData = this.props.listViewTableData;
        this.state = {
            activeRunFilter:0,
            detailJobId: '',
            detailPipelineName: '',
            pipelinedatasource: null,
            timefilter: "12",
            pipelinelist: null,
            filterpipelinelist: null,
            selectedPipeline: [],
            selectedDataSourceID: null,
            isInFullScreenMode: false,
            startDate: startDate,
            endDate: endDate,
            selectedDatasource: null,
            datasets: [],
            currListViewTableData: listViewTableData,
            dataFilteredValues: [],
            completeTableData: listViewTableData,
            defaultDatasourceInside: null,
            latest_job_run_time: null,
            timeFilterApplied: false,
            fullScreenData: null,
            fullScreenAttributeData: null,
            keyData: `dqListView_${listViewTableData.length}`,
            initial: {
                datasource: "",
                dataset: "",
                attribute: "",
            },
            pipelinesource_data:"-1",
            initialendDate:endDate,
            initialstartDate:startDate,
            pipelinesource_filter:[],
            page_selected_pipeline:'',
            cur_page_selected_pipeline:1,
            paginationtrack:1,
            filter_pipeline_id:"All",
            detailJobList:[],
            selectedJobDetailsFailedRuns:'',
            selectedJobDetailsSucessRuns:'',
            selectedJobDetails:'',
            selectedPipelineInfo:'',
            tableData:null,
            selectedJobRuns:"",
            more_job_runid:"",
            searchText:"",
            isFilterMode:true,
            monitor_pipeline_list:[],
            pipeline_source_list:[],
            api_call_loader:1,
            enableFadeLoader:false,
            errMessage:"",
            showSpinner:false,
            pipeline_integrations:[],
            clearall_pipeline_integrations_id:''
        }
    }

    toggleFilter() {
        let filterMode = this.state.isFilterMode ? false : true;
        this.setState({
            isFilterMode: filterMode,
            // enableFadeLoader:true,
        })
    }

    gotoPipelineConfigure(){
        let redirectPage = "/pipeline"
        if(this.props.navigatePage !== undefined){
            redirectPage = this.props.navigatePage
        }
        browserHistory.push(redirectPage);
    }

    resetRunView(){
        this.setState({"more_job_runid":""});
    }
    activeRun(e){
        const isChecked = e.target.checked;
        this.setState({"activeRunFilter":isChecked ? 1:0,enableFadeLoader:true});
        setTimeout(
            () => {

                if($('.react-bootstrap-table > table:nth-child(1) > thead:nth-child(1) > tr:nth-child(1) > th').length === 3){

                $(".table>thead>tr").append("<th>Datasource Type</th>");
                $(".table>thead>tr").append("<th>Last Run</th>");
                $(".table>thead>tr").append("<th>Last Run <br/>Duration</th>");
                $(".table>thead>tr").append("<th>Avg.<br/>Duration</th>");
                $(".table>thead>tr").append("<th>Next<br/>Scheduled<br/>Run</th>");
                $(".table>thead>tr").append("<th>Runs Count</th>");
                $(".table>thead>tr").append("<th>Last Run<br/>Status</th>");
                $(".table>thead>tr").append("<th>Action</th>");
                $('.react-bootstrap-table > table:nth-child(1) > tbody:nth-child(2) > tr:nth-child(1) > td:nth-child(1)').html("");
                $('.table th:nth-child(1)').html("");
                $(".react-table__info,.react-table__length").hide();
                let ths = $('th');
                    let element = ths.eq(0);
                    element.width(0);
                    element = ths.eq(1);
                    element.width(190);
                    element = ths.eq(2);
                    element.width(216);
                    element = ths.eq(3);
                    element.width(402);
                    element = ths.eq(4);
                    element.width(85);
                    element = ths.eq(5);
                    element.width(70);
                    element = ths.eq(6);
                    element.width(60);
                    element = ths.eq(7);
                    element.width(85);
                    element = ths.eq(8);
                    element.width(100);
                    element = ths.eq(9);
                    element.width(85);
                    element = ths.eq(10);
                    element.width(70);
                }
                    this.applyTimeFilter(parseInt(this.state.timefilter),"functioncall");
            },
            2
          );
    }
    applyTablewrapperClasses(){
        if(parseInt(this.state.timefilter) === 12 || parseInt(this.state.timefilter) === 24){
            return "table-responsive pipeline-table";
        }else {
            return "table-responsive pipeline-table tbl-time-range--selected";
        }
    }
    pageTrack(pmCurrentpage){
        this.setState({"paginationtrack":pmCurrentpage,
        page_selected_pipeline:'',
        cur_page_selected_pipeline:1,
        enableFadeLoader:true
        });

    }
    nextDate(){
        var endDate = moment(this.state.endDate);
        endDate = endDate.add(1, "days");
        endDate = this.state.initialendDate > endDate ? endDate : this.state.initialendDate;
        if(endDate === this.state.initialendDate){
            $("#btn_pipline_next").attr("disabled","true")
        }else {
            $("#btn_pipline_next").removeAttr("disabled")
        }
        if (endDate.isAfter(moment(this.state.pipeline_created_time), 'day')) {
            $("#btn_pipline_prev").removeAttr("disabled");
        }
        let filteredData = [];
        let dataFilteredValues = [];
        this.setState({
            startDate: endDate,
            endDate: endDate,
            dataFilteredValues: dataFilteredValues,
            timeFilterApplied: true,
            currListViewTableData: filteredData,
            enableFadeLoader:true
        },()=>this.applyTimeFilter(this.state.timefilter,"nextdatecall"));

    }   
    prevDate() {
        let endDate = moment(this.state.endDate)
        let EndDate_prev = endDate;
        let PipelineCreatedTime = moment(this.state.pipeline_created_time);

    if (EndDate_prev.isSame(PipelineCreatedTime, 'day')) {
        $("#btn_pipline_prev").attr("disabled", "true");
    } else {
        $("#btn_pipline_prev").removeAttr("disabled");
    }

        if (endDate.isSame(moment(this.state.initialendDate), 'day')) {
            $("#btn_pipline_next").removeAttr("disabled");
        }

        let filteredData = [];
        let dataFilteredValues = [];
        this.setState({
           // startDate: startDate,
           // endDate: startDate,
            dataFilteredValues: dataFilteredValues,
            timeFilterApplied: true,
            currListViewTableData: filteredData,
            enableFadeLoader:true
        },()=>this.applyTimeFilter(this.state.timefilter,"datecall"));
    } 
    nowDate() {
        let  endDate = moment(this.state.initialendDate);
        let filteredData = [];
        let dataFilteredValues = [];
        this.setState({
            startDate: endDate,
            endDate: endDate,
            dataFilteredValues: dataFilteredValues,
            timeFilterApplied: true,
            currListViewTableData: filteredData,
            enableFadeLoader:true
        },()=>this.applyTimeFilter(this.state.timefilter,"functioncall"));
    } 

pipelinesourceFilterSelection() {
    let filter = [];
    $('input:checkbox[name=defaulErrorCheck]:checked').each(function() 
    {
        filter.push($(this).val());
    });
    this.setState({"pipelinesource_filter":filter,enableFadeLoader:true});
}

    applyTimeFilterNow(){
        this.setState({
                       endDate:this.state.initialendDate,
                       startDate:this.state.initialstartDate,
                       enableFadeLoader:true
                    }
                      );
    } 
    applyTimeFilter(time,calltype) {
      if(parseInt(time) === 12 || parseInt(time) === 24){
        $("th").eq(3).html(
        `<div class="tbl-time-range">
                                                            <div class="tbl-time-range__header">
                                                                <label> Last Day Schedule - <strong id="lastSechduleDate">`+this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)+`</strong> (GMT)</label>
                                                                <label>
                                                                </label>
                                                                <ul class="tbl-time-range__list">
                                                                    <li id="chart_time_1">&nbsp;</li>
                                                                    <li id="chart_time_2">&nbsp;</li>
                                                                    <li id="chart_time_3">&nbsp;</li>
                                                                    <li id="chart_time_4">&nbsp;</li>
                                                                    <li id="chart_time_5">&nbsp;</li>
                                                                    <li id="chart_time_6">&nbsp;</li>
                                                                    <li id="chart_time_7">&nbsp;</li>
                                                                    <li id="chart_time_8">&nbsp;</li>
                                                                    <li id="chart_time_9">&nbsp;</li>
                                                                    <li id="chart_time_10">&nbsp;</li>
                                                                    <li id="chart_time_11">&nbsp;</li>
                                                                    <li id="chart_time_12">&nbsp;</li>
                                                                    <li id="chart_time_13">&nbsp;</li>
                                                                    <!--<li id="chart_time_13">&nbsp;</li>-->
                                                                </ul>
                                                            </div>
                                                        </div>
        `
        );
    }else {

        $("th").eq(3).html(
            `<div class="tbl-time-range">
                                                                <div class="tbl-time-range__header">
                                                                    <label> Last Day Schedule - <strong id="lastSechduleDate">`+this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)+`</strong> (GMT)</label>
                                                                    <label>
                                                                    </label>
                                                                    <ul class="tbl-time-range__list">
                                                                    <!--<li id="chart_time">&nbsp;</li>-->
                                                                        <li id="chart_time_1">&nbsp;</li>
                                                                        <li id="chart_time_2">&nbsp;</li>
                                                                        <li id="chart_time_3">&nbsp;</li>
                                                                        <li id="chart_time_4">&nbsp;</li>
                                                                        <li id="chart_time_5">&nbsp;</li>
                                                                        <li id="chart_time_6">&nbsp;</li>
                                                                        <li id="chart_time_7">&nbsp;</li>
                                                                    </ul>
                                                                </div>
                                                            </div>
            `
            );
    }
    this.timeFilterRenderHtml(time,calltype);
    if(time==="0"){
        this.setState({ "timefilter":parseInt(1),endDate:this.state.initialendDate,startDate:this.state.initialstartDate});
    }else{
        this.setState({ "timefilter":parseInt(time),enableFadeLoader : calltype==="initialcall" ? false  : true});
    }
 }
 timeFilterRenderHtml_old(time){
    let timelen;
    if(parseInt(time) === 12 || parseInt(time) === 24){
        timelen = 13;
    }
    else {
        timelen = 9;
    }

    let curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate).set({ "hour": 23, "minute": 59, "seconds": 59 })
    let timeserieshrs = parseInt(time);
    let timeseriesmins = moment(curdate)
    .subtract({'hours':parseInt(time)})
    .format('mm')
    ;
    timeseriesmins = 0;
    for(let loop=1; loop<=timelen;loop++){
    if(parseInt(time) ===12 || parseInt(time) === 24 ||  parseInt(time) === 6){

        if(parseInt(time) ===12 || parseInt(time) === 6){
            $("#chart_time_"+loop).html(moment(curdate)
            .subtract({'hours':timeserieshrs})
            .format('hh A'));
            timeserieshrs = parseInt(timeserieshrs)-1
        }else if(parseInt(time) === 24) {
            $("#chart_time_"+loop).html(moment(curdate)
            .subtract({'hours':timeserieshrs})
            .format('hh A'));
            timeserieshrs = parseInt(timeserieshrs)-2
        }
    } else {
        let curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate).set({ "hour": 23, "minute": 59, "seconds": 59 })
        $("#chart_time_"+(timelen-loop)).html(moment(curdate)
        .subtract({'minutes': timeseriesmins})
        .format('hh:mm A'));
        if(loop===1){
            timeseriesmins = parseInt(timeseriesmins)+parseInt(9)
        }else {
            timeseriesmins = parseInt(timeseriesmins)+parseInt(10)
        }
    }
    }
 }

 timeFilterRenderHtml(time,calltype){
    let timelen;
    if(parseInt(time) === 12 || parseInt(time) === 24){
        timelen = 13;
    }
    else {
        timelen = 9;
    }
    let curdate;
    if(calltype==="functioncall"){
        curdate = moment(this.state.endDate).isSame(moment(), 'day') ? moment().utc() : moment(this.state.endDate).set({ "hour": 23, "minute": 59, "seconds": 59 })
    }else if (calltype === "nextdatecall") {
            if (parseInt(time) === 24) {
                curdate = moment(this.state.endDate).add(1, "days");
            }else {
                curdate = moment(this.state.endDate).add(parseInt(time), "hours");
            }
    }else {
        curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate)
    }
    let timeserieshrs = parseInt(time);
    let timeseriesmins = moment(curdate)
    .subtract({'hours':parseInt(time)})
    .format('mm');
    timeseriesmins = 0;

    for(let loop=1; loop<=timelen;loop++){
    if(parseInt(time) ===12 || parseInt(time) === 24 ||  parseInt(time) === 6){

        if(parseInt(time) ===12 || parseInt(time) === 6){
            $("#chart_time_"+loop).html(moment(curdate)
            .subtract({'hours':timeserieshrs})
            .format('hh A'));
            timeserieshrs = parseInt(timeserieshrs)-1
        }else if(parseInt(time) === 24) {
            $("#chart_time_"+loop).html(moment(curdate)
            .subtract({'hours':timeserieshrs})
            .format('hh A'));
            timeserieshrs = parseInt(timeserieshrs)-2
        }
    } else {
        // let curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate).set({ "hour": 23, "minute": 59, "seconds": 59 })
        $("#chart_time_"+(timelen-loop)).html(moment(curdate)
        .subtract({'minutes': timeseriesmins})
        .format('hh:mm A'));
        if(loop===1){
            timeseriesmins = parseInt(timeseriesmins)+parseInt(9)
        }else {
            timeseriesmins = parseInt(timeseriesmins)+parseInt(10)
        }
    }
    }

    if(calltype==="functioncall"){
        curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate).set({ "hour": 23, "minute": 59, "seconds": 59 })
    }else {
        if(parseInt(time) ===12 || parseInt(time) === 24 ||  parseInt(time) === 6){
            curdate = moment(curdate).subtract({'hours':parseInt(time)});
        }else {
            curdate = moment(curdate).subtract({'hours':parseInt(time)});
        }
     }
     if (calltype === "datecall" || calltype === "nextdatecall" || calltype === "functioncall") {
        this.setState({ endDate: curdate, startDate: curdate });
    }
 }

getData() {
    this.getApi("get_pipeline_monitor");
}


    errMessage(){
            let pmflag = 2;
            if(pmflag===1){
            return(<><div className="react-bootstrap-table__header">
                                                <div className="row">
                                                    <div className="col-4">
                                                        <div className="btn-group react-table__length" role="group">
                                                            <span>Show</span>
                                                            <select className="select-sm" id="paging" style={{ backgroundColor: "#fff", border: "1px solid #CED4DA", padding: "4px 10px", margin: "0 5px", color: "#484848" }}>
                                                                <option value="5">5</option>
                                                                <option value="10">10</option>
                                                                <option value="20">20</option>
                                                                <option value="all">all</option>
                                                            </select>
                                                            <span>items</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-8">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <Form.Check 
                                                                type="switch"
                                                                id="custom-switch"
                                                                label="Active Runs Only"
                                                                className="custom-switch-sm mr-3"
                                                                onChange={this.activeRun}
                                                            />
                                                            
                                                            <div className="btn-toolbar mr-2">
                                                                <div className="btn-toolbar__wrap">
                                                                    <div className="btn-toolbar__item">
                                                                        <Button variant=" ">Now</Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="btn-toolbar mr-2">
                                                                <div className="btn-toolbar__wrap">
                                                                    <div className="btn-toolbar__item">
                                                                        <Button onClick={this.timeFilter.bind(this, "1")} variant=" " className={this.state.timefilter === "1hr" ? "active" : " "}>1hr</Button>
                                                                    </div>
                                                                    <div className="btn-toolbar__item">
                                                                        <Button onClick={this.timeFilter.bind(this, "6")} variant=" " className={this.state.timefilter === "6hr" ? "active" : " "}>6hr</Button>
                                                                    </div>
                                                                    <div className="btn-toolbar__item">
                                                                        <Button onClick={this.timeFilter.bind(this, "12")} variant=" " className={this.state.timefilter === "12hr" ? "active" : " "}>12hr</Button>
                                                                    </div>
                                                                    <div className="btn-toolbar__item">
                                                                        <Button onClick={this.timeFilter.bind(this, "24")} variant=" " className={this.state.timefilter === "24hr" ? "active" : " "} >24hr</Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="btn-toolbar mr-3">
                                                                <div className="btn-toolbar__wrap">
                                                                    <div className="btn-toolbar__item">
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle variant=" " id="dropdown-basic">
                                                                                <svg className="" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="18"
                                                                                    viewBox="0 0 24 24" width="18">
                                                                                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                                                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                                                </svg>
                                                                                <span className="filter-count">0</span>
                                                                                {/* d-inline-flex */}
                                                                                <span className="ml-1">Filter</span>
                                                                            </Dropdown.Toggle>
    
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item href="/"className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-running" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-running">
                                                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                <g clip-path="url(#clip0_263_199)">
                                                                                                    <path d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76V7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="currentColor" />
                                                                                                </g>
                                                                                                <defs>
                                                                                                    <clipPath id="clip0_263_199">
                                                                                                        <rect width="24" height="24" fill="white" />
                                                                                                    </clipPath>
                                                                                                </defs>
                                                                                            </svg>
                                                                                            <span className="ml-1">Running</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item> 
                                                                                <Dropdown.Item href="/#" className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-scheduled" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-scheduled">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z" /></g></g></g></svg>
                                                                                            <span className="ml-1">Scheduled</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item href="/#" className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-progress" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-progress">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                                                                                            <span className="ml-1">In Progress</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item href="/#" className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-queued" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-queued">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                                                                                            <span className="ml-1">Queued</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item href="/#" className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-done" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-done">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                                                                            <span className="ml-1">Success</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item href="/#" className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-failed" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-failed">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                                                            <span className="ml-1">Failed</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item href="#/action-3" className="py-1">
                                                                                    <div className="custom-control custom-checkbox custom-control-inline">
                                                                                        <Form.Control
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            name="defaulErrorCheck"
                                                                                            id="pipeline-cancelled" />
                                                                                        <Form.Label className="custom-control-label" for="pipeline-cancelled">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                                                            <span className="ml-1">Cancelled</span>
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </div>
                                                            </div>
    
                                                            <div className="btn-group react-table__filter" role="group">
                                                                <span>Search:</span>
                                                                <div className="table-search">
                                                                    <input placeholder="Search" id="searchBox"
                                                                        className="form-control" style={{ backgroundColor: "#ffffff" }}
                                                                        type="text" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="react-bootstrap-table table-responsive pipeline-table">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th width="10">R.No</th>
                                                            <th width="200">Pipeline Source</th>
                                                            <th width="229">Jobs</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr>
                                                        <td colSpan={11}>
                                                        <div className="row">
                        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                            <div className="placeholder-msg">
                                <div className="placeholder-msg__icon">
                                    <Image src="icon_placeholder_no_pipeline_data" />
                                </div>
                                <p>No items were found for this search criteria.</p>
                            </div>
                        </div>
                    </div>
                                                        </td></tr>              
    
                                                    </tbody>
                                                </table>
                                            </div> </>);
            }
    
            if(pmflag===2 && this.state.activeRunFilter === 0){
                return (<div className="row">
                <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <div className="placeholder-msg">
                        <div className="placeholder-msg__icon">
                            <Image src="icon_placeholder_pipeline_configure" />
                        </div>
                        <div className="placeholder-msg__text">
                            <h6>No Pipeline Sources</h6>
                            <p>No Pipeline source connector configured</p>
                        </div>
                        <div className="placeholder-msg__action">
                            <button onClick={this.gotoPipelineConfigure} className="btn btn-outline btn-grey btn-circle"><i><FontAwesomeIcon icon={faPlusCircle} /></i>Add Pipelines Source</button>
                        </div>
                    </div>
                </div>
            </div>)
    
            }

            if(pmflag===2 && this.state.activeRunFilter === 1){
                return (<div className="row">
                <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <div className="placeholder-msg">
                        <div className="placeholder-msg__icon">
                            <Image src="icon_placeholder_pipeline_configure" />
                        </div>
                        <div className="placeholder-msg__text">
                            <h6>Active Runs Not Found</h6>
                            {/* <p>No Pipeline source connector configured</p> */}
                        </div>
                        {/* <div className="placeholder-msg__action">
                            <button onClick={this.gotoPipelineConfigure} className="btn btn-outline btn-grey btn-circle"><i><FontAwesomeIcon icon={faPlusCircle} /></i>Add Pipelines Source</button>
                        </div> */}
                    </div>
                </div>
            </div>)
            }
    }
   

    millisecondToMinutesAndSeconds(millis) {
        millis = parseInt(millis);
        if(isNaN(millis) === true){
          return;
        }
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        if(minutes<1){
            return seconds +"s";
        }else{
            return minutes + "m" + (seconds < 10 ? '' : '') + seconds +"s";
        }
    }
    formatUTCDate(Your_Date){
            return moment.utc(Your_Date).format("DD MMM HH:mm");
    }
    
    renderJobsSourceHtml(row,rowIndex){
         $("#lastSechduleDate").html(this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT))
        // let timeline = {"timeline": [{
        //     "date": "15-01-2023",
        //     "start": "13:41",
        //     "end": "13:45",
        //     "status": "success"
        // }]}
            let newarray; 
            let newarraydepend = [];
            let builddependdata = [];
            let startpage,endpage,totalpage,arrtotalpage=[];
            if(pipeline_page_cnt < row.Jobs.value.format_jobs_result.length) {
                totalpage = Math.round(row.Jobs.value.format_jobs_result.length/pipeline_page_cnt);
                for (let i = 1; i <= totalpage; i++) {
                    arrtotalpage.push(i);
                }
            }else {
                totalpage = 0;
            }
                        if(row.Jobs.value.format_jobs_result.length) {

            if(parseInt(row.Jobs.value.format_jobs_result[0].pipeline_integration_id) ===  parseInt(this.state.page_selected_pipeline)){
                if(this.state.cur_page_selected_pipeline === 1){
                    startpage = 0;
                    endpage = pipeline_page_cnt < row.Jobs.value.format_jobs_result.length ? pipeline_page_cnt : row.Jobs.value.pipelinedata.length
                }else{
                    startpage = (parseInt(this.state.cur_page_selected_pipeline)-1) * parseInt(pipeline_page_cnt);
                    endpage = startpage+pipeline_page_cnt;
                    endpage = endpage < row.Jobs.value.format_jobs_result.length ? endpage : row.Jobs.value.pipelinedata.length
                }
            }
            else {
                startpage = 0;
                endpage = pipeline_page_cnt < row.Jobs.value.format_jobs_result.length ? pipeline_page_cnt : row.Jobs.value.format_jobs_result.length
            }

        }
            let pagedata = row.Jobs.value.format_jobs_result.slice(startpage, endpage);
            if (pagedata.length === 0) {
                let message = this.state.activeRunFilter === 1
                    ? "No active runs identified for the chosen date."
                    : "No items were found for this search criteria.";

                return (
                    <div className="row text-center">
                        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                            <div className="placeholder-msg">
                                <div className="placeholder-msg__icon">
                                    <Image src="icon_placeholder_no_pipeline_data" />
                                </div>
                                <p>{message}</p>
                            </div>
                        </div>
                    </div>
                );
            }
            let pipelineindex = pagedata[0].pipeline_integration_id;
            let is_parent = pagedata[0].is_parent;
            let childjob_search = pagedata.every(job => job.is_parent === "false");
            if (is_parent === "false" && childjob_search) {
                let message = this.state.activeRunFilter === 1
                    ? "No active runs identified for the chosen date."
                    : "No items were found for this search criteria.";
                return (
                    <div className="row text-center">
                        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                            <div className="placeholder-msg">
                                <div className="placeholder-msg__icon">
                                    <Image src="icon_placeholder_no_pipeline_data" />
                                </div>
                                <p>{message}</p>
                            </div>
                        </div>
                    </div>
                );
            }

            return(<table className="table table-tree">
            <tbody>
            {
            pagedata.map((pipelinejob, pipelinejobindex) => {
            newarray = pipelinejob;
            if(newarray!=="" && newarray!==undefined){
                if(pipelinejob.hasOwnProperty('dependent_job') === true ){
                    newarraydepend = pipelinejob.dependent_job;
                    builddependdata.length = 0;
                    if(newarraydepend!==undefined){
                        for(let dependloop=0;dependloop<newarraydepend.length;dependloop++){
                            for(let dependinnnerloop=0;dependinnnerloop<row.Jobs.value.full_format_jobs_result.length;dependinnnerloop++){
                                if(newarraydepend[dependloop]===row.Jobs.value.full_format_jobs_result[dependinnnerloop].pipeline_job_id) {
                                    builddependdata.push(row.Jobs.value.full_format_jobs_result[dependinnnerloop])
                                }
                            }
                        }
                    }
                } 
                let lastRun = newarray.runsjob
                lastRun =  lastRun.length - 1
                let last_run = newarray.runsjob[lastRun] && newarray.runsjob[lastRun].run_started_time

                let failedcntflag;
                if(pipelinejob.hasOwnProperty('dependent_job') === true){
                failedcntflag  = builddependdata.filter(function(item){
                    return item.status === "Failed";         
                }).length
                }
                return (
                    pipelinejob.hasOwnProperty('dependent_job') === true ?
                    <>
                    <tr id={"toggle_" + pipelineindex + "_" + pipelinejobindex}>
                    <td width="29">
                        <div id={pipelineindex + "_" + pipelinejobindex} 
                        className={failedcntflag > 0 ? "table-tree__toggle has-failed-jobs" : "table-tree__toggle"} onClick={this.handlePipelineTreeTriger.bind(this, pipelineindex + "_" + pipelinejobindex)}>
                        <i className="table-tree__toggle-icon"></i>
                        </div>
                    </td>
                    <td width="200">
                        <div className="table-tree__label"><span>{newarray.job_name}</span></div>
                    </td>
                    <td width="410" className="pt-0">
                        {this.showGraph(pipelinejob,'testst',)}
                    </td>
                    <td width="95">{this.formatUTCDate(last_run)}</td>
                    <td width="80"><div className="tbl-last-duration">{this.millisecondToMinutesAndSeconds(newarray.last_duration)}</div></td>
                    <td width="70">
                        <div className="d-flex align-items-center">
                        <span>{this.millisecondToMinutesAndSeconds(newarray.avg_duration)}</span>
                        </div>
                    </td>
                    <td width="95">N/A</td>
                    <td width="110">
                    <div className="tbl-job-attempts">
                        {parseInt(newarray.success_count)  >  0 ?
                        <div className="badge success-attempt-badge">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#9F9F9F">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                            </svg>
                            <span className="text-dark">{newarray.success_count}</span>
                        </div> : ""}
                        {   parseInt(newarray.failed_count)  >  0 ?
                        <div className="badge failed-attempt-badge ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#9F9F9F">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                            </svg>
                            <span className="text-dark">{newarray.failed_count}</span>
                        </div> : "" }
                        </div>
                    </td>
                    <td width="95">
                        {this.statusIcon(newarray.status)}
                    </td>
                    <td width="80">
                        <button id={"more_"+pipelinejob.pipeline_job_id} className="btn btn-light" onClick={this.setFullScreen.bind(this, newarray.pipelinesourcename, pipelinejob.pipeline_job_id,row.Jobs.value.full_format_jobs_result,newarray)}> More
                        <i className="ml-1">
                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#484848">
                            <rect fill="none" height="24" width="16" />
                            <path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z" />
                        </svg>
                        </i>
                        </button>
                    </td>
                    </tr>
                    <tr id={pipelineindex + "_" + pipelinejobindex + "-nested"} className="table-tree__nested">
                    <td colspan="11">
                        <table className="table table-tree">
                        <tbody>
                            {
                            builddependdata!==undefined ?    
                            builddependdata.map((stage, index) => {
                                let last_Run = stage.runsjob
                                last_Run =  last_Run.length - 1
                                let last_run = stage.runsjob[last_Run] && stage.runsjob[last_Run].run_started_time
                            return (
                            <tr>
                                <td width="29">
                                </td>
                                <td width="200">
                                    <div className="table-tree__label"><span>{stage.job_name}</span></div>
                                </td>
                                <td width="410" className="parent">
                                   { this.showGraph(stage,stage.status) }
                                </td>
                                <td width="95" className="border-left-0">{this.formatUTCDate(last_run)}</td>
                                <td width="80"><div className="tbl-last-duration">{this.millisecondToMinutesAndSeconds(stage.last_duration)}</div></td>
                                <td width="70">
                                    {this.millisecondToMinutesAndSeconds(stage.avg_duration)}
                                </td>
                                <td width="95">N/A</td>
                                <td width="110">
                                    <div className="tbl-job-attempts">
                                    {  
                                    parseInt(stage.success_count)  >  0 ?
                                    <div className="badge success-attempt-badge">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#9F9F9F">
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                        </svg>
                                        <span className="px-1 text-dark">{stage.success_count}</span>
                                    </div> : ""
                                    }
                                    {   parseInt(stage.failed_count)  >  0 ?
                                    <div className="badge failed-attempt-badge ml-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#9F9F9F">
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                                        </svg>
                                        <span className="px-1 text-dark">{stage.failed_count}</span>
                                    </div> : "" }
                                    </div>
                                </td>
                                <td width="95">
                                    {this.statusIcon(stage.status)}
                                </td>
                                <td width="80">
                                    <button id={"more_"+stage.pipeline_job_id}  onClick={this.setFullScreen.bind(this, stage.pipelinesourcename, stage.pipeline_job_id,row.Jobs.value.full_format_jobs_result,newarray)} className="btn btn-light">More
                                    <i className="ml-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#484848">
                                        <rect fill="none" height="24" width="16" />
                                        <path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z" />
                                    </svg>
                                    </i>
                                    </button>
                                </td>
                            </tr>
                            )
                            }) : ""
                            }
                        </tbody>
                        </table>
                    </td>
                    </tr>
                    </> :
                    is_parent === "true" ? 
                    <>
                    <tr id={"toggle_" + pipelineindex + "_" + pipelinejobindex}>
                    <td width="29">
                        
                        <div id={pipelineindex + "_" + pipelinejobindex} 
                        className={newarray.status==="Failed" ? "table-tree__toggle disabled" : "table-tree__toggle disabled"}
                        >
                        <RcTooltip placement="top"
                            overlay={
                            <span>No Dependent Jobs</span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                            <i className="table-tree__toggle-icon"></i>
                            </RcTooltip>
                        </div>
                    </td>
                    <td width="200">
                        <div className="table-tree__label"><span>{newarray.job_name}</span></div>
                    </td>
                    <td width="410" className="pt-0">
                        {this.showGraph(pipelinejob,newarray.status)}
                    </td>
                    <td width="95">{this.formatUTCDate(last_run)}</td>
                    <td width="80"><div className="tbl-last-duration has-indicator--">{this.millisecondToMinutesAndSeconds(newarray.last_duration)}</div></td>
                    <td width="70">
                        {this.millisecondToMinutesAndSeconds(newarray.avg_duration)}
                    </td>
                    <td width="95">N/A</td>
                    <td width="110">

                        <div className="tbl-job-attempts">
                        {parseInt(newarray.success_count)  >  0 ?
                        <div className="badge success-attempt-badge">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#9F9F9F">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                            </svg>
                            <span className="text-dark">{newarray.success_count}</span>
                        </div> : ""}
                        {   parseInt(newarray.failed_count)  >  0 ?
                        <div className="badge failed-attempt-badge ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#9F9F9F">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                            </svg>
                            <span className="text-dark">{newarray.failed_count}</span>
                        </div> : "" }
                        </div>
                    </td>
                    <td width="95">
                        {this.statusIcon(newarray.status)}
                    </td>
                    <td width="80">
                        <button id={"more_"+pipelinejob.pipeline_job_id} className="btn btn-light" onClick={this.setFullScreen.bind(this, newarray.pipelinesourcename, pipelinejob.pipeline_job_id,row.Jobs.value.full_format_jobs_result,newarray)}> More
                        <i className="ml-1">
                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#484848">
                            <rect fill="none" height="24" width="16" />
                            <path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z" />
                        </svg>
                        </i>
                        </button>
                    </td>
                    </tr>
                    </> : "") 
            }else {
                return (<div></div>);
            }
            })}
            { row.Jobs.value.format_jobs_result.length > 0 &&  (row.Jobs.value.format_jobs_result.length > pipeline_first_click_page_cnt) ?
            <tr>
                <td colSpan="20" style={{width:"100%"}} className="react-bootstrap-table__footer table-tree__footer">
                        <div className="row no-gutters">
                        { parseInt(this.state.page_selected_pipeline) !== parseInt(pipelineindex) ?
                            <div className={"col-6 paging_fotter_close"+pipelineindex}>
                            <button data-view="0" data-pipelineindex={pipelineindex} onClick={this.paging.bind(this,pipelineindex)} className="btn btn-link tbl-tree__expand-btn d-flex align-items-center">
                                <i className="mr-1">
                                    {
                                // this.state.showSpinner ? <span className="spinner-border spinner-border-xs spinner-border-gray d-block"></span>
                                // : <FontAwesomeIcon icon={faAngleDoubleDown} />
                                }
<span id="page_spinner" className='d-none'><span  className=" spinner-border spinner-border-xs spinner-border-gray d-block"></span></span>
<span id="page_expand" ><FontAwesomeIcon icon={faAngleDoubleDown} /></span>
                                </i>
                                {pipeline_page_cnt} of {row.Jobs.value.format_jobs_result !== null ? row.Jobs.value.format_jobs_result.length : 0} rows - Click to view all Jobs
                            </button>
                            </div>
                            :
                            <>
                            <div className={"col-6 paging_fotter_exand"+pipelineindex}>
                            <button data-view="1" data-pipelineindex={pipelineindex}  onClick={this.pagingreset.bind(this, pipelineindex)} className="btn btn-link tbl-tree__expand-btn --is-expanded">
                                <i className="mr-1">
                                   <FontAwesomeIcon icon={faAngleDoubleDown} />
                                </i>
                                Exit & Collapse this view
                            </button>
                            </div>
                        <div className="col-6">
                            {pipeline_page_cnt > pipeline_second_click_page_page_cnt ?
                            <ul class="pagination react-bootstrap-table-page-btns-ul">
                                {
                                    parseInt(startpage) === 0 ? 
                                    ""
                                    :
                                    <>
                                    {/* <li class="page-item" title="first page"><a href={() => false}  class="page-link">&lt;&lt;</a></li> */}
                                    <li onClick={this.innerpage} data-page-id={parseInt(this.state.cur_page_selected_pipeline)-1} class="page-item" title="previous page" ><a onClick={this.innerpage} data-page-id={parseInt(this.state.cur_page_selected_pipeline)-1} href={() => false}  class="page-link">&lt;</a></li>
                                    </>  
                                }
                                {
                                    arrtotalpage.map((user) => (
                                        <li  onClick={this.innerpage} data-page-id={user} class={parseInt(user)===parseInt(this.state.cur_page_selected_pipeline) ? "active page-item" : "page-item"}  title={user}><a onClick={this.innerpage} data-page-id={user} href={() => false}  class="page-link">{user}</a></li>
                                    ))
                                }

                                {parseInt(this.state.cur_page_selected_pipeline)===parseInt(totalpage) ?
                                "" :
                                <li  onClick={this.innerpage} data-page-id={parseInt(this.state.cur_page_selected_pipeline)+1} class="page-item" title="next page"><a href={() => false}  onClick={this.innerpage} data-page-id={parseInt(this.state.cur_page_selected_pipeline)+1} class="page-link">&gt;</a></li>
                                }
                                {/* <li class="page-item" title="last page"><a href={() => false}  class="page-link">&gt;&gt;</a></li> */}
                            </ul> : ""}
                        </div>
                        </>
                        }
                        </div>
                        </td>
            </tr> : ""
}
            </tbody>
            </table>)

    }

    renderPipelineSourceHtml(row,rowIndex){
        let active_runs=0,totalcnt=0,failedcnt=0,sucesscnt=0;
         let filterdate = moment(this.state.endDate).format('Y-MM-DD');
         let initalfilterdate = moment(this.state.endDate).format('Y-MM-DD');
         totalcnt =  row.Jobs.value.pipelinedata.length;
         if(totalcnt > 0){
            for(let loop=0;loop<totalcnt;loop++){
                if(!row.Jobs.value.pipelinedata[loop]['payload'].hasOwnProperty(initalfilterdate)){
                    // var firstKey = Object.keys(row.Jobs.value.pipelinedata[loop]['payload'])[0];
                    // filterdate = firstKey;
                    var firstKey =  row.Jobs.value.pipelinedata[loop]['payload'].time_stamp[row.Jobs.value.pipelinedata[loop]['payload'].time_stamp.length-1]
                    filterdate = firstKey;
                }else {
                    filterdate = initalfilterdate;
                    const entries = row.Jobs.value.pipelinedata[loop]['payload'][filterdate];
                        if (entries && entries.length > 0) {
                            let latestEntry = entries[entries.length - 1];
                            if (latestEntry["status"] !== undefined) {
                                active_runs++;
                                if (latestEntry["status"] === "Succeeded") {
                                    sucesscnt++;
                                }
                                if (latestEntry["status"] === "Failed") {
                                    failedcnt++;
                                }
                            }
                        }
                }

                // else {
                //     failedcnt++;
                // }
            }
         }
        return (
            <>
            <p className="text-info mb-2"><i className="mr-1"><FontAwesomeIcon icon={faAsterisk} /></i>{row['Jobs']["value"]["pipelinesourcename"]}</p>
            <div className="alert moniker-alert" role="alert">
                <p>{this.state.latest_job_run_time !== null || this.state.latest_job_run_time=== undefined ? moment(this.state.latest_job_run_time.replace("GMT","")).format('Y-MM-DD hh:mm:ss') : "--"}
                    <RcTooltip
                        placement="right"
                        overlay={
                            <span>Your last job ran at <br /><strong>{moment(this.state.latest_job_run_time.replace("GMT","")).format('Y-MM-DD hh:mm:ss')}</strong></span>
                        }
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                    >
                        <i className="icon-info-circle"></i>
                    </RcTooltip>
                </p>
            </div>
            <div className="qd-connector-box">
   <div className="qd-connector-box__header">
      <label className="qd-connector-box__label">Connector</label>
      { row['Jobs']["value"]["pipeline_type"] === "synapse" ?
            <Image src="connector_logo_azure_synapse" alt="" /> :
        row['Jobs']["value"]["pipeline_type"] === "airflow" ?   
           <Image src="connector_logo_airflow" alt="" />
          :
          row['Jobs']["value"]["pipeline_type"] === "adf" ?   
          <Image src="connector_logo_adf" alt="" />
          :
          row['Jobs']["value"]["pipeline_type"] === "glue" ?
          <Image src="connector_logo_glue" alt="" />
          :row['Jobs']["value"]["pipeline_type"] === "composer" ?
          <Image src="connector_logo_cloud_composer" alt="" />:
          ""
      }
   </div>
   <div className="qd-connector-box__body">
      <ul className="connector-list">
         <li>
            <p>
               <span className="text-muted">
                  <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                     <g>
                        <rect fill="none" height="24" width="24" />
                     </g>
                     <g>
                        <path d="M15,22h4c1.1,0,2-0.9,2-2v-3c0-1.1-0.9-2-2-2h-1v-2c0-1.1-0.9-2-2-2h-3V9h1c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2h-4 C8.9,2,8,2.9,8,4v3c0,1.1,0.9,2,2,2h1v2H8c-1.1,0-2,0.9-2,2v2H5c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-3 c0-1.1-0.9-2-2-2H8v-2h8v2h-1c-1.1,0-2,0.9-2,2v3C13,21.1,13.9,22,15,22z" />
                     </g>
                  </svg>
                  <label className="ml-1">Total No of Jobs</label>
               </span>
               <strong>{totalcnt}</strong>
            </p>
         </li>
         <li>
            <p>
               <span className="text-blue">
                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none"/><path d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                </svg>
                <label className="ml-1">Active Jobs</label>
               </span>
               <strong>{active_runs}</strong>
            </p>
         </li>
         <li>
            <p>
               <span className="text-success">
                  <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                     <path d="M0 0h24v24H0z" fill="none" />
                     <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                  <label className="ml-1">Successful Jobs</label>
               </span>
               <strong>{
        sucesscnt}</strong>
            </p>
         </li>
         <li>
            <p>
               <span className="text-danger">
                  <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                     <path d="M0 0h24v24H0z" fill="none" />
                     <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                  </svg>
                  <label className="ml-1">Failed Jobs</label>
               </span>
               <strong>{failedcnt}</strong>
            </p>
         </li>

         {/* <li>
            <p>
               <span className="text-muted">
                  <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                     <path d="M0 0h24v24H0z" fill="none" />
                     <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                  </svg>
                  <label className="ml-1">Last Profiled At</label>
               </span>
               <strong>&nbsp;{moment(row.Jobs.value.pipelinedata[0]["latest_job_run_time"]).format('Y-MM-DD MM:SS')}</strong>
            </p>
         </li> */}
      </ul>
   </div>
</div>
</>
        )
    }

    datewisejobsdata(pmData, skip){
        if(this.state.enableFadeLoader === true){
            $(".portlet > .portlet-body").addClass("qd-content-loading")
            $(".qd-tab__content-action").addClass("qd-content-loading")
            $(".qd-filter-section").addClass("qd-content-loading")
        }
         let newarray = [];
         let filterdate = moment(this.state.endDate).format('Y-MM-DD');
         let initalfilterdate = moment(this.state.endDate).format('Y-MM-DD');
         let gant_show_flag,active_runs = 0;

        let selectedTimeFilter = this.state.timefilter;
        let endTime = moment(this.state.endDate);
        let startTime = moment(endTime).subtract(selectedTimeFilter, 'hours');

        for(let loop=0;loop<pmData.pipelinedata.length;loop++){
            // This Condition is used on search bar for skipping the jobs for the jobs column in bootstrap table
            if (skip !== "skip" &&
                this.state.searchText.length > 0 &&
                pmData.pipelinedata[loop]['job_name']!== undefined &&
                pmData.pipelinedata[loop]['job_name']!== null &&
                !pmData.pipelinedata[loop]['job_name'].toLowerCase().includes(this.state.searchText.toLowerCase()) &&
                !pmData['pipelinesourcename'].toLowerCase().includes(this.state.searchText.toLowerCase())
            ){
                continue;
             }

            if(pmData.pipelinedata[loop].payload!==undefined){
                if(!pmData.pipelinedata[loop].payload.hasOwnProperty(initalfilterdate) && this.state.activeRunFilter===0){
                    var firstKey =  pmData.pipelinedata[loop].payload.time_stamp[pmData.pipelinedata[loop].payload.time_stamp.length-1]
                    filterdate = firstKey;
                    gant_show_flag = 0
                    if(pmData.pipelinedata[loop].payload[initalfilterdate]!==undefined){
                        active_runs = pmData.pipelinedata[loop].payload[initalfilterdate].length;
                    }
                }else {
                    filterdate = initalfilterdate;
                    gant_show_flag = 1
                    if(pmData.pipelinedata[loop].payload[filterdate]!==undefined){
                        active_runs = pmData.pipelinedata[loop].payload[filterdate].length;
                    }
                }
                let nextDate = "NA";
                let previousDate = "NA";
                if(pmData.pipelinedata[loop].payload.time_stamp.length > 0) {
                   let previousindex = pmData.pipelinedata[loop].payload.time_stamp.indexOf(filterdate)
                   previousDate = pmData.pipelinedata[loop].payload.time_stamp[previousindex === 0 || previousindex ===-1 ? 0 : previousindex-1];
                   nextDate = pmData.pipelinedata[loop].payload.time_stamp[previousindex===pmData.pipelinedata[loop].payload.time_stamp.length-1 ? "NA" :  previousindex+1];
                   if(nextDate===undefined){
                    nextDate = "NA";
                   }
                }
                if (pmData.pipelinedata[loop].payload[filterdate] !== undefined) {
                    if ((pmData.pipelinedata[loop].payload[filterdate].length > 0 && this.state.pipelinesource_filter.length === 0) ||
                        (pmData.pipelinedata[loop].payload[filterdate].length > 0 && this.state.pipelinesource_filter.length > 0 &&
                         this.state.pipelinesource_filter.includes(pmData.pipelinedata[loop].payload[filterdate][pmData.pipelinedata[loop].payload[filterdate].length - 1]['status']))) {

                        let jobsWithinTimeRange = pmData.pipelinedata[loop].payload[filterdate]?.filter(job => {
                            let jobRunEndTime = moment(job.run_end_time);
                            return jobRunEndTime.isBetween(startTime, endTime);
                        }) || [];


                // Check conditions to push jobs to the array
                if (jobsWithinTimeRange.length > 0 || !this.state.activeRunFilter) {
                    let obj = {};
                    obj.pipeline_type = pmData.pipeline_type;
                    obj.pipelinesourcename = pmData.pipelinesourcename;
                    obj.tenant_id = pmData.tenant_id;
                    obj.is_parent = pmData.pipelinedata[loop]['is_parent'];
                    obj.job_name = pmData.pipelinedata[loop]['job_name'];
                    obj.pipeline_integration_id = pmData.pipelinedata[loop]['pipeline_integration_id'];
                    obj.pipeline_job_id = pmData.pipelinedata[loop]['pipeline_job_id'];

                    let avg = 0;
                    if (pmData.pipelinedata[loop].payload["avg_duration_list"].hasOwnProperty(filterdate)) {
                        avg = pmData.pipelinedata[loop].payload["avg_duration_list"][filterdate];
                    }
                    obj.avg_duration = avg;

                    if (pmData.pipelinedata[loop].payload.hasOwnProperty('dependent_job')) {
                        obj.dependent_job = pmData.pipelinedata[loop].payload.dependent_job[filterdate] ||
                                            pmData.pipelinedata[loop].payload.dependent_job[Object.keys(pmData.pipelinedata[loop].payload.dependent_job).pop()];
                    }

                    obj.status = pmData.pipelinedata[loop].payload[filterdate][pmData.pipelinedata[loop].payload[filterdate].length-1]['status'];
                    obj.total_runs    = pmData.pipelinedata[loop].payload[filterdate].length;
                    obj.success_count = pmData.pipelinedata[loop].payload[filterdate].filter(function(item){
                       return item.status === "Succeeded";
                   }).length
                    obj.failed_count  = pmData.pipelinedata[loop].payload[filterdate].filter(function(item){
                       return item.status === "Failed";
                   }).length

                    obj.last_run      = pmData.pipelinedata[loop].payload[filterdate][pmData.pipelinedata[loop].payload[filterdate].length-1]["run_end_time"]
                    obj.last_duration = pmData.pipelinedata[loop].payload[filterdate][pmData.pipelinedata[loop].payload[filterdate].length-1]["duration"]
                    obj.runsjob     = pmData.pipelinedata[loop].payload[filterdate]
                    obj.staus     = pmData.pipelinedata[loop].payload[filterdate]
                    obj.successjobs = pmData.successjobs;
                    obj.failedjobs = pmData.failedjobs;
                    obj.totaljobs = pmData.totaljobs;
                    obj.latest_job_run_time = pmData.pipelinedata[0]['latest_job_run_time'];
                    obj.gant_show_flag = gant_show_flag;
                    obj.active_runs = active_runs;
                    obj.previousdate = previousDate;
                    obj.nextDate = nextDate;
                    newarray.push(obj);
                }
            }
        }
        }
       }

        if(this.state.enableFadeLoader){
            this.setState({
                "enableFadeLoader": false})
        setTimeout(
            () => {
        $(".portlet > .portlet-body").removeClass("qd-content-loading")
        $(".qd-tab__content-action").removeClass("qd-content-loading")
        $(".qd-filter-section").removeClass("qd-content-loading")
            },1000)
        }

        if(this.state.api_call_loader === 1){
            this.setState({api_call_loader:0})
        }

        return newarray;
    }



    pipelineSourceTableData(pmEndDate){
      let input_data = this.state.pipelinesource_data;
      let headers=["Pipeline Source", "Jobs"];
      let final_op=[];
      let pipelinesource = [];
      let jobs = [];
      for(let i=0; i < input_data.length; i++) {
            if(i===0){
                pipelinesource.push({ "label": "All", "value": "All" });
            }
            pipelinesource.push({ "label": input_data[i].pipeline_integration_name, "value": input_data[i].pipeline_integration_id });
            

            if(this.state.filter_pipeline_id === "All" || this.state.filter_pipeline_id === input_data[i].pipeline_integration_id  ){
            input_data[i].pipelinesourcename = input_data[i].pipeline_integration_name
            input_data[i].page_selected_pipeline = this.state.page_selected_pipeline;
            input_data[i].cur_page_selected_pipeline = this.state.cur_page_selected_pipeline;
            input_data[i].pipelinesourcetype = "synapse"
            input_data[i].successjobs = input_data[i].success_count
            input_data[i].failedjobs = input_data[i].failed_count
            input_data[i].totaljobs = input_data[i].total_count
            input_data[i].endDate =  this.state.endDate;
            input_data[i].timefilter =  this.state.timefilter;
            input_data[i].paginationtrack =  this.state.paginationtrack;
            input_data[i].format_jobs_result =  this.datewisejobsdata(input_data[i]);
            input_data[i].full_format_jobs_result =  this.datewisejobsdata(input_data[i],"skip");

            let activerunfiltercheck = 1;
            for(let loop = 0; loop<input_data[i].format_jobs_result.length;loop++){
                if(input_data[i].format_jobs_result[loop]['runsjob'].length > 0){
                    activerunfiltercheck = 0;
                }
            }
            let row = [];
            let d = input_data[i];
            row.push({"value": d["pipelinesourcename"], "type": "component"});
            if(this.state.activeRunFilter === 1 && activerunfiltercheck === 0){
                jobs.push({ "label": input_data[i].pipelinedata[0].payload[input_data[i].pipelinedata[0].payload.time_stamp[0]][0].job_name, "value": input_data[i].pipelinedata[0].payload[input_data[i].pipelinedata[0].payload.time_stamp[0]][0].job_name });
                row.push({"value": d, "type": "component"});
            } else if(this.state.activeRunFilter === 0){
                jobs.push({ "label": input_data[i].pipelinedata[0].payload[input_data[i].pipelinedata[0].payload.time_stamp[0]][0].job_name, "value": input_data[i].pipelinedata[0].payload[input_data[i].pipelinedata[0].payload.time_stamp[0]][0].job_name });
                row.push({"value": d, "type": "component"});
            } else if(this.state.activeRunFilter === 1 && activerunfiltercheck === 1) {
                jobs.push({ "label": "No jobs available", "value": "No jobs available" });
                row.push({"value": d, "type": "component"});
            }
            final_op.push(row)
            }
            }
        let table_data ={"headers": headers, "data": final_op};
        return [table_data,pipelinesource,jobs];
    }

    handlePipelineTreeTriger(test, val) {
        $('#' + test + '-nested').toggleClass("is-open");
        $('#toggle_' + test).toggleClass("table-tree--parent");
    }
    filterData(pmValue, source) {
        let allvalues = JSON.parse(localStorage.getItem("piplineinitaldata"))
        if (source === 'pipelinedatasource') {
            let filterdat = allvalues;
            let filterdata = [];
            let filterdatlen = filterdat.length;
            for (let loop = 0; loop < filterdatlen; loop++) {
                if (filterdat[loop]["metadata"]["pipeline_name"] === pmValue.value) {
                    filterdata.push(filterdat[loop]);
                }
            }
            let datasets = []
            for (let loop = 0; loop < filterdata[0]['jobs'].length; loop++) {
                datasets.push({ "value": filterdata[0]['jobs'][loop]['job_id'], "label": filterdata[0]['jobs'][loop]['job_name'] });
            }
            this.setState({
                "datasets": datasets,
                "selectedPipeline": [],
                "filterpipelinelist": filterdata,
                "selectedDatasource": pmValue,
                enableFadeLoader:true
            });
        }

        if (source === 'pipelinejob') {

            if (pmValue.length > 0) {

                if (pmValue[0].label === "All") {

                    let filterdat = allvalues;
                    let filterdata = [];
                    let filterdatlen = filterdat.length;
                    for (let loop = 0; loop < filterdatlen; loop++) {
                        if (filterdat[loop]["metadata"]["pipeline_name"] === this.state.selectedDatasource.value) {
                            filterdata.push(filterdat[loop]);
                        }
                    }
                    let datasets = []
                    for (let loop = 0; loop < filterdata[0]['jobs'].length; loop++) {
                        datasets.push({ "value": filterdata[0]['jobs'][loop]['job_id'], "label": filterdata[0]['jobs'][loop]['job_name'] });
                    }
                    this.setState({
                        "datasets": datasets,
                        "filterpipelinelist": filterdata,
                         enableFadeLoader:true
                    });

                } else {

                  //  let filterdat = allvalues;
                    let filterdata = [];
                    let filterdatlen = allvalues.length;


                    for (let loop = 0; loop < filterdatlen; loop++) {
                        if (allvalues[loop]["metadata"]["pipeline_name"] === this.state.selectedDatasource.value) {
                            filterdata.push(allvalues[loop]);
                        }
                    }

                    let joblist = [];
                    for (let loop = 0; loop < pmValue.length; loop++) {
                        joblist.push(pmValue[loop]['value']);
                    }

                    let joblistfilter = [];
                    for (let loop = 0; loop < filterdata[0]['jobs'].length; loop++) {
                        let index = joblist.indexOf(filterdata[0]['jobs'][loop]['job_id']);
                        if (index > -1) {
                            joblistfilter.push(filterdata[0]['jobs'][loop])
                        }
                    }
                    this.setState({
                        "datasets": this.state.datasets,
                        "selectedPipeline": pmValue,
                        "filterpipelinelist": filterdata,
                    });
                }
            } else {

                let filterdat = allvalues;
                let filterdata = [];
                let filterdatlen = filterdat.length;
                for (let loop = 0; loop < filterdatlen; loop++) {
                    if (filterdat[loop]["metadata"]["pipeline_name"] === this.state.selectedDatasource.value) {
                        filterdata.push(filterdat[loop]);
                    }
                }
                let datasets = []
                for (let loop = 0; loop < filterdata[0]['jobs'].length; loop++) {
                    datasets.push({ "value": filterdata[0]['jobs'][loop]['job_id'], "label": filterdata[0]['jobs'][loop]['job_name'] });
                }
                this.setState({
                    "datasets": datasets,
                    "selectedPipeline": [],
                    "filterpipelinelist": filterdata
                });
            }
        }

    }
    componentDidMount() {
        this.getData();
        let latestdate = this.props.dataModule.lastProfilingTime;
        if (latestdate !== null && latestdate !== undefined) {
         //   let maxDate, minDate, str, date = [];
         let minDate, str, date = [];
            latestdate = Object.keys(latestdate).forEach(function (key, index) {
                let lastProfiledDate = latestdate[key];
                if (lastProfiledDate === null) {
                    // Here 'return' is equivalent to 
                    // 'continue' in conventional for loop
                    return;
                }

                str = lastProfiledDate.substring(0, lastProfiledDate.length - 13);
                date.push(moment(str));
            });

            if (date.length > 0) {
               // maxDate = moment.max(date).set({ "hour": 23, "minute": 59, "seconds": 59 })
                minDate = moment.min(date)
                if (minDate !== "" && minDate !== "") {
                    // this.setState({
                    //     startDate: minDate,
                    //     endDate: maxDate,
                    // });
                }
            }

        }

    }
    setFullScreen(pm, jobid,jobslist,newarray) {
        this.setState({
                isInFullScreenMode: true,
                detailJobId: jobid,
                detailPipelineName: pm,
                detailJobList:jobslist,
                selectedPipelineInfo:newarray
        },() => {
            this.getApi("get_pipeline_run_details");
        });
        $('body').css('overflow', 'hidden');
    }
    changePipelineSource(selectedDataSource) {
        let lastmodifiedrecord,pipeliencreated;
        if(this.state.monitor_pipeline_list.length > 0){
                             lastmodifiedrecord  = this.state.monitor_pipeline_list.filter(function(item){
                                return item.pipeline_integration_id  === selectedDataSource.value;
            })
        }
        if(this.state.pipeline_integrations.length > 0){

            pipeliencreated  = this.state.pipeline_integrations.filter(function(item){
                return item.pipeline_integration_id  === selectedDataSource.value;
            })
        }
        this.setState(
            {
                "pipeline_created_time":pipeliencreated[0]['created_time'],
                "selectedDatasource": selectedDataSource,
                "tableData":null,
                "filter_pipeline_id":selectedDataSource.value,
                "latest_job_run_time":lastmodifiedrecord[0]["latest_job_run_time"],
                "api_call_loader":1,
                startDate: this.state.initialendDate,
                endDate: this.state.initialendDate,
                activeRunFilter: 0,
                searchText: "",
            },
            () => {
                this.getApi("get_pipelineprefetch");
            }
          );
    }

    handlePipelineListViewTimeFilter(event, picker) {
        let startDate = picker.startDate;
        let endDate = picker.endDate;
        let filteredData = [];
        let dataFilteredValues = [];
        this.setState({
            startDate: startDate,
            endDate: endDate,
            dataFilteredValues: dataFilteredValues,
            timeFilterApplied: true,
            currListViewTableData: filteredData
        });
        this.applyTimeFilter(this.state.timefilter,"functioncall")
        $("#lastSechduleDate").html(endDate.format(PIPELINE_DISPLAY_DATE_FORMAT))
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    closeFullScreenMode() {
        //    document.body.classList.remove("overflow-hidden");
        this.setState({
            isInFullScreenMode: false
        });
        $('body').css('overflow', 'auto');
    }
    statusColor(status){
        let color;
        if (status === "Succeeded") {
            color = "#4ED2CC";
        }
        if (status === "Failed") {
            color = "#F64E60";
        }
        if (status === "Cancelled") {
            color = "#F64E60";
        }
        return color;
    }

    handleClearAll(){
        let filteredData = [];
        let dataFilteredValues = [];
        if(this.state.pipeline_integrations.length > 0){
            let integrations_id =  this.state.clearall_pipeline_integrations_id;
            let lastmodifiedrecord  = this.state.pipeline_integrations.filter(function(item){
                return item.pipeline_integration_id  === integrations_id;
            })
            if(lastmodifiedrecord.length > 0){
            this.setState(
                {
                    "selectedDatasource": { "label": lastmodifiedrecord[0].pipeline_integration_name, "value": lastmodifiedrecord[0].pipeline_integration_id },
                    "filter_pipeline_id":lastmodifiedrecord[0]["pipeline_integration_id"],
                    "latest_job_run_time":lastmodifiedrecord[0]["latest_job_run_time"],
                    "pipeline_created_time":lastmodifiedrecord[0]["created_time"],
                    "startDate": this.state.initialendDate,
                    "endDate": this.state.initialendDate,
                    "dataFilteredValues": dataFilteredValues,
                    "timeFilterApplied": true,
                    "currListViewTableData": filteredData,
                    "api_call_loader":1,
                    "tableData":null,
                    "enableFadeLoader":true,
                },
                () => {
                    this.getApi("get_pipelineprefetch");
                })
                $("#lastSechduleDate").html(this.state.initialendDate.format(PIPELINE_DISPLAY_DATE_FORMAT))
            }
        }
    }

minsPosition(index,time,mins){
    // mins[index]
    if(time === 12 || time === 6){
        if(mins[index] < 15){
            return "5px"
        }
        else if(mins[index] > 15 || mins[index] < 30 ){
            return "10px"
        }
        else if(mins[index] > 30 || mins[index] < 45 ){
            return "15px"
        }
        else {
            return "20px"
        }
    }
    return "10px"
    // return 10;
}

showGraph(pmstatus,status){
    //Time Calculation
    let TIME_SLOT = []
    let time = parseInt(this.state.timefilter);
    let timelen;
        if(parseInt(time) === 12 || parseInt(time) === 24){
            timelen = 13;
        }
        else {
            timelen = 7;
        }

        let curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate)
        let timeserieshrs = parseInt(time);

        if(parseInt(time) === 1){
            curdate = moment(curdate)
            .subtract({'hours':2,minutes:0})
            curdate = moment(curdate)
            .add({minutes:1})

        }

        let timeseriesmins = moment(curdate)
        .subtract({'hours':timeserieshrs})
        .format('mm');
        timeseriesmins = 50;


        for(let loop=1; loop<=timelen;loop++){
        if(parseInt(time) ===12 || parseInt(time) === 24 ||  parseInt(time) === 6){
            if(parseInt(time) ===12 || parseInt(time) === 6){
                TIME_SLOT.push(moment(curdate)
                .subtract({'hours':timeserieshrs})
                .format('HH'));
                timeserieshrs = parseInt(timeserieshrs)-1
            }else if(parseInt(time) ===24) {
                    TIME_SLOT.push(moment(curdate)
                .subtract({'hours':timeserieshrs})
                .format('HH'));
                timeserieshrs = parseInt(timeserieshrs)-2
            }
        } else {

            TIME_SLOT.push(moment(curdate)
            .add({'minutes': timeseriesmins})
            .format('HH:mm'));
            timeseriesmins = parseInt(timeseriesmins)+parseInt(10)
        }
        }

            let runtimehours   = [];
            let runtimemins    = [];
            let runstatus      = [];
            let runduration    = [];
            let rundate        = [];

            for(let loop=0;loop<pmstatus.runsjob.length;loop++){
                if(pmstatus.runsjob[loop]["run_started_time"]!==undefined){
                let timeformat = pmstatus.runsjob[loop]["run_started_time"].split(".")[0].replace("T"," ")
                timeformat = timeformat.split(" ");
                let datearr = timeformat[0].split("-");
                timeformat = timeformat[1].split(":");
                let hours = timeformat[0]
                let mins  = timeformat[1]
                runtimehours.push(hours);
                runtimemins.push(mins);
                rundate.push(datearr[2])
                runstatus.push(pmstatus.runsjob[loop]["status"]);

            let  durationdiff = moment.duration(moment(pmstatus.runsjob[loop]["run_end_time"]).diff(moment(pmstatus.runsjob[loop]["run_started_time"])));
            let durationdiffmin = durationdiff.asMinutes();
            let width = 2;
            let roundduration = parseInt(Math.ceil(durationdiffmin/60))
            if(roundduration === 1){
                width =4
            }
            else if(roundduration > 1 && roundduration <= 3){
                width = 5
            }
            else{
                width = 6
            }
            runduration.push(width)
            }
        }
            let chartcolor;
            return <div class="tbl-time-range__content">
                    <div class="tbl-time-range__cols">
                        <div class="tbl-time-range__col">
                        <RcTooltip placement="top"
    overlay={
    <span>Previous Run Date: <strong className="font-weight-bold text-nowrap">{pmstatus.previousdate}</strong></span>
    }
    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
    >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill="#F9FBFD" />
        <g clip-path="url(#clip0_923_34)">
            <path d="M8 13H12V11H8V8L4 12L8 16V13ZM15 13C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11C14.45 11 14 11.45 14 12C14 12.55 14.45 13 15 13Z" fill="currentColor" />
            <path d="M18 4H20C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20H18V4Z" fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_923_34">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
    </RcTooltip>
                        </div>
                        {
                        TIME_SLOT.map((person, i) => {
                        let show  = false;
                        let width,marginleft=0;
                        if(time === 12 || time === 6){
                            chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
                            show  = runtimehours.indexOf(person) > -1 && pmstatus.gant_show_flag === 1
                            width = runduration[runtimehours.indexOf(person)]
                            marginleft = this.minsPosition(runtimehours.indexOf(person,time,runtimemins));
                        }
                        if(time === 24 ){
                            chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
                            let tw_hrs = parseInt(person)+1;
                            if(tw_hrs<10){
                                tw_hrs = String("0"+tw_hrs);
                            }else{
                                tw_hrs = String(tw_hrs);
                            }
                            chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
                            if(chartcolor === undefined){
                                chartcolor = this.statusColor(runstatus[runtimehours.indexOf(tw_hrs)])
                            }
                            show  = ((runtimehours.indexOf(person) > -1 && pmstatus.gant_show_flag === 1 && i!==0) || (runtimehours.indexOf(tw_hrs) > -1 && pmstatus.gant_show_flag === 1))
                            width = runduration[runtimehours.indexOf(person)]==="" ? runduration[runtimehours.indexOf(tw_hrs)] : runduration[runtimehours.indexOf(person)]
                            marginleft = this.minsPosition(runtimehours.indexOf(person,time,runtimemins));
                        }

                        else if(time === 1 ){
                            let onehrs_hh = person.split(":")[0]
                            let onehrs_mm = person.split(":")[1]
                            for(let onehrsloop=0;onehrsloop<runtimehours.length;onehrsloop++){
                                if(runtimehours[onehrsloop]+":"+runtimemins <= onehrs_hh+":"+onehrs_mm && runtimehours[onehrsloop]+":"+runtimemins >= onehrs_hh+":"+onehrs_mm ){
                                    show = true;
                                    width = runduration[runtimehours.indexOf(onehrs_hh)]
                                    chartcolor = this.statusColor(runstatus[runtimehours.indexOf(onehrs_hh)])
                                    marginleft = this.minsPosition(runtimehours.indexOf(onehrs_hh,time,runtimemins));
                                }else {
                                    show = false;
                                }
                            }
                        }
    return(<div class="tbl-time-range__col">
    {
    show === true  ?
    <>
    <OverlayTrigger trigger="click" rootClose placement="right" overlay={
           <Popover className="pipeline-popover">
           <Popover.Title as="h3" id="pipeline_popover_title"></Popover.Title>
           <Popover.Content>
               <div id="pipeline_popover_content">
               </div>
           </Popover.Content>
       </Popover>
    }>
    <span className={pmstatus.status_code!==undefined ? pmstatus.status_code ===2 ? "bg-striped-lines--green" : "" : ""}  onClick={this.getGanttPopover.bind(this,pmstatus.pipeline_job_id,pmstatus)} style={{ width: width + "px", height: "16px", backgroundColor: chartcolor,position:'absolute',left:marginleft}}>&nbsp;{pmstatus.status_code}</span>
    </OverlayTrigger>
    </>
    : ""

    }
    { i+1 === TIME_SLOT.length ?
        <RcTooltip placement="top"
    overlay={
    <span>Next Run Date: <strong className="font-weight-bold text-nowrap">{pmstatus.nextDate}</strong>
    </span>
    }
    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
    >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="24" rx="4" transform="matrix(-1 0 0 1 24 0)" fill="#F9FBFD" />
                                    <g clip-path="url(#clip0_923_40)">
                                        <path d="M16 13H12V11H16V8L20 12L16 16V13ZM9 13C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11C9.55 11 10 11.45 10 12C10 12.55 9.55 13 9 13Z" fill="currentColor" />
                                        <path d="M6 4H4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H6V4Z" fill="currentColor" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_923_40">
                                            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                                        </clipPath>
                                    </defs>
                                </svg>
    </RcTooltip> : "" }
                        </div>)
                        })
                    }
                    </div>
                    {

                        this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)
                        === this.state.initialendDate.format(PIPELINE_DISPLAY_DATE_FORMAT) ?
                    <div class="tbl-time-range__now">
                    </div> : ""
                }
                </div>
        }

showGraph_(pmstatus,status){
//Time Calculation
let TIME_SLOT = []
let time = parseInt(this.state.timefilter);
let timelen;
    if(parseInt(time) === 12 || parseInt(time) === 24){
        timelen = 13;
    }
    else {
        timelen = 7;
    }

    let curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate).set({ "hour": 23, "minute": 59, "seconds": 59 })
    let timeserieshrs = parseInt(time);

    if(parseInt(time) === 1){
        curdate = moment(curdate)
        .subtract({'hours':2,minutes:0})
        curdate = moment(curdate)
        .add({minutes:1})

    }

    let timeseriesmins = moment(curdate)
    .subtract({'hours':timeserieshrs})
    .format('mm');
    timeseriesmins = 50;


    for(let loop=1; loop<=timelen;loop++){
    if(parseInt(time) ===12 || parseInt(time) === 24 ||  parseInt(time) === 6){
        if(parseInt(time) ===12 || parseInt(time) === 6){
            TIME_SLOT.push(moment(curdate)
            .subtract({'hours':timeserieshrs})
            .format('HH'));
            timeserieshrs = parseInt(timeserieshrs)-1
        }else if(parseInt(time) ===24) {
                TIME_SLOT.push(moment(curdate)
            .subtract({'hours':timeserieshrs})
            .format('HH'));
            timeserieshrs = parseInt(timeserieshrs)-2
        }
    } else {

        TIME_SLOT.push(moment(curdate)
        .add({'minutes': timeseriesmins})
        .format('HH:mm'));
        timeseriesmins = parseInt(timeseriesmins)+parseInt(10)

        // console.log("timeseriesmins"+timeseriesmins)
        // console.log("test"+timeseriesmins+"--"+curdate)
        // if(loop===1){
        //     timeseriesmins = parseInt(timeseriesmins)+parseInt(12)
        // }
        // else if(loop===2){
        //     timeseriesmins = parseInt(timeseriesmins)+parseInt(8)
        // }
        // else {
        //     timeseriesmins = parseInt(timeseriesmins)+parseInt(10)
        // }

    }
    }

    // console.log("Enter Time Series");
    // console.log(TIME_SLOT)
    // console.log("**************");

        let runtimehours   = [];
        let runtimemins    = [];
        let runstatus      = [];
        let runduration    = [];
        let rundate        = [];

        for(let loop=0;loop<pmstatus.runsjob.length;loop++){
            if(pmstatus.runsjob[loop]["run_started_time"]!==undefined){
            let timeformat = pmstatus.runsjob[loop]["run_started_time"].split(".")[0].replace("T"," ")
            timeformat = timeformat.split(" ");
            let datearr = timeformat[0].split("-");
            timeformat = timeformat[1].split(":");
            let hours = timeformat[0]
            let mins  = timeformat[1]
            runtimehours.push(hours);
            runtimemins.push(mins);
            rundate.push(datearr[2])
            runstatus.push(pmstatus.runsjob[loop]["status"]);

        let  durationdiff = moment.duration(moment(pmstatus.runsjob[loop]["run_end_time"]).diff(moment(pmstatus.runsjob[loop]["run_started_time"])));
        let durationdiffmin = durationdiff.asMinutes();
        let width = 2;
        let roundduration = parseInt(Math.ceil(durationdiffmin/60))
        if(roundduration === 1){
            width =4
        }
        else if(roundduration > 1 && roundduration <= 3){
            width = 5
        }
        else{
            width = 6
        }
        runduration.push(width)
        }
    }
        let chartcolor;
        return <div class="tbl-time-range__content">
                <div class="tbl-time-range__cols">
                    <div class="tbl-time-range__col">
                    <RcTooltip placement="top"
overlay={
<span>Previous Run Date: <strong className="font-weight-bold text-nowrap">{pmstatus.previousdate}</strong></span>
}
arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
>
<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#F9FBFD" />
    <g clip-path="url(#clip0_923_34)">
        <path d="M8 13H12V11H8V8L4 12L8 16V13ZM15 13C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11C14.45 11 14 11.45 14 12C14 12.55 14.45 13 15 13Z" fill="currentColor" />
        <path d="M18 4H20C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20H18V4Z" fill="currentColor" />
    </g>
    <defs>
        <clipPath id="clip0_923_34">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>
</RcTooltip>
                    </div>
                    {
                    TIME_SLOT.map((person, i) => {
                    let show  = false;
                    let width,marginleft=0;
                    if(time === 12 || time === 6){
                        chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
                        show  = runtimehours.indexOf(person) > -1 && pmstatus.gant_show_flag === 1
                        width = runduration[runtimehours.indexOf(person)]
                        marginleft = this.minsPosition(runtimehours.indexOf(person,time,runtimemins));
                    }
                    if(time === 24 ){
                        chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
                        let tw_hrs = parseInt(person)+1;
                        if(tw_hrs<10){
                            tw_hrs = String("0"+tw_hrs);
                        }else{
                            tw_hrs = String(tw_hrs);
                        }
                        chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
                        if(chartcolor === undefined){
                            chartcolor = this.statusColor(runstatus[runtimehours.indexOf(tw_hrs)])
                        }
                        show  = ((runtimehours.indexOf(person) > -1 && pmstatus.gant_show_flag === 1 && i!==0) || (runtimehours.indexOf(tw_hrs) > -1 && pmstatus.gant_show_flag === 1))
                        width = runduration[runtimehours.indexOf(person)]==="" ? runduration[runtimehours.indexOf(tw_hrs)] : runduration[runtimehours.indexOf(person)]
                        marginleft = this.minsPosition(runtimehours.indexOf(person,time,runtimemins));
                    }

                    else if(time === 1 ){
                        let onehrs_hh = person.split(":")[0]
                        let onehrs_mm = person.split(":")[1]
                        for(let onehrsloop=0;onehrsloop<runtimehours.length;onehrsloop++){
                            // console.log(runtimehours[onehrsloop] <= onehrs_hh+":"+onehrs_mm)
                            // console.log(runtimehours[onehrsloop]);
                            // console.log(onehrs_hh+":"+onehrs_mm);
                            if(runtimehours[onehrsloop]+":"+runtimemins <= onehrs_hh+":"+onehrs_mm && runtimehours[onehrsloop]+":"+runtimemins >= onehrs_hh+":"+onehrs_mm ){
                                show = true;
                                width = runduration[runtimehours.indexOf(onehrs_hh)]
                                chartcolor = this.statusColor(runstatus[runtimehours.indexOf(onehrs_hh)])
                                marginleft = this.minsPosition(runtimehours.indexOf(onehrs_hh,time,runtimemins));
                            }else {
                                show = false;
                            }
                        }
                    }
return(<div class="tbl-time-range__col">
{
show === true  ?
<>
<OverlayTrigger trigger="click" rootClose placement="right" overlay={
       <Popover className="pipeline-popover">
       <Popover.Title as="h3" id="pipeline_popover_title"></Popover.Title>
       <Popover.Content>
           <div id="pipeline_popover_content">
           </div>
       </Popover.Content>
   </Popover>
}>
<span className={pmstatus.status_code!==undefined ? pmstatus.status_code ===2 ? "bg-striped-lines--green" : "" : ""}  onClick={this.getGanttPopover.bind(this,pmstatus.pipeline_job_id,pmstatus)} style={{ width: width + "px", height: "16px", backgroundColor: chartcolor,position:'absolute',left:marginleft}}>&nbsp;{pmstatus.status_code}</span>
</OverlayTrigger>
</>
: ""

}
{ i+1 === TIME_SLOT.length ?
    <RcTooltip placement="top"
overlay={
<span>Next Run Date: <strong className="font-weight-bold text-nowrap">{pmstatus.nextDate}</strong>
</span>
}
arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
>
<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="24" height="24" rx="4" transform="matrix(-1 0 0 1 24 0)" fill="#F9FBFD" />
                                <g clip-path="url(#clip0_923_40)">
                                    <path d="M16 13H12V11H16V8L20 12L16 16V13ZM9 13C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11C9.55 11 10 11.45 10 12C10 12.55 9.55 13 9 13Z" fill="currentColor" />
                                    <path d="M6 4H4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H6V4Z" fill="currentColor" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_923_40">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                                    </clipPath>
                                </defs>
                            </svg>
</RcTooltip> : "" }
                    </div>)
                    })
                }
                </div>
                {

                    this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)
                    === this.state.initialendDate.format(PIPELINE_DISPLAY_DATE_FORMAT) ?
                <div class="tbl-time-range__now">
                </div> : ""
            }
            </div>
    }

    statusIcon(pmStatus) {
        if (pmStatus === "Cancelled") {
            return <div className="d-flex align-items-center text-orange">
                        <svg width="16" height="16" className="mr-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1 1.7V4.703C10.1 4.801 10.065 4.885 10.002 4.948L8.252 6.698C8.112 6.838 7.895 6.838 7.755 6.698L6.005 4.948C5.935 4.885 5.9 4.794 5.9 4.703V1.7C5.9 1.315 6.215 1 6.6 1H9.4C9.785 1 10.1 1.315 10.1 1.7ZM1.7 5.9H4.703C4.801 5.9 4.885 5.935 4.948 5.998L6.698 7.748C6.838 7.888 6.838 8.105 6.698 8.245L4.948 9.995C4.885 10.065 4.794 10.1 4.703 10.1H1.7C1.315 10.1 1 9.785 1 9.4V6.6C1 6.215 1.315 5.9 1.7 5.9ZM5.9 14.3V11.297C5.9 11.199 5.935 11.115 5.998 11.052L7.748 9.302C7.888 9.162 8.105 9.162 8.245 9.302L9.5534 10.6104C9.20316 11.1554 9 11.804 9 12.5C9 13.3871 9.33003 14.1971 9.874 14.814C9.74907 14.9293 9.58239 15 9.4 15H6.6C6.215 15 5.9 14.685 5.9 14.3ZM14.8175 9.87713C14.9307 9.75264 15 9.58752 15 9.407V6.607C15 6.222 14.685 5.907 14.3 5.907H11.297C11.199 5.9 11.115 5.935 11.045 6.005L9.295 7.755C9.155 7.895 9.155 8.112 9.295 8.252L10.6019 9.55889C11.1487 9.20528 11.8004 9 12.5 9C13.3888 9 14.2002 9.33129 14.8175 9.87713Z" fill="currentColor"></path><path d="M11.72 13.9867L12.6533 13.0533L13.5867 13.9867L13.9867 13.5867L13.0667 12.6667L14 11.7333L13.6 11.3333L12.6667 12.2667L11.7333 11.3333L11.3333 11.7333L12.2667 12.6667L11.3333 13.6L11.72 13.9867ZM12.6667 15.3333C11.9289 15.3333 11.3 15.0733 10.78 14.5533C10.26 14.0333 10 13.4044 10 12.6667C10 11.9289 10.26 11.3 10.78 10.78C11.3 10.26 11.9289 10 12.6667 10C13.4044 10 14.0333 10.26 14.5533 10.78C15.0733 11.3 15.3333 11.9289 15.3333 12.6667C15.3333 13.4044 15.0733 14.0333 14.5533 14.5533C14.0333 15.0733 13.4044 15.3333 12.6667 15.3333Z" fill="currentColor"></path></svg>Cancelled
                    </div>
        }
        if (pmStatus === "Succeeded") {
            return <div className="d-flex align-items-center text-success">
                <svg xmlns="http://www.w3.org/2000/svg" height="16px" className="mr-1" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                Success
            </div>
        }
        else if (pmStatus === "Failed") {
            return <div className="d-flex align-items-center text-danger">
                <svg xmlns="http://www.w3.org/2000/svg" height="16px" className="mr-1" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                Failed
            </div>
        }
        else if (pmStatus === "Schedules" || pmStatus === "Scheduled") {
            return <div className="d-flex align-items-center text-purple">
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" className="mr-1" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z" /></g></g></g></svg>
                Scheduled
            </div>
        }
        else if (pmStatus === "In Progre") {
            return <div className="d-flex align-items-center text-info">
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" className="mr-1" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                In Progress
            </div>
        }
        else if (pmStatus === "Queued") {
            return <div className="d-flex align-items-center text-warning">
                <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" className="mr-1" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                Queued
            </div>
        }
    }

    innerpage(event){
        this.setState({cur_page_selected_pipeline:event.target.attributes.getNamedItem('data-page-id').value})
    }

    paging(pm, pmid) {
        $("#page_spinner").removeClass("d-none")
        $("#page_expand").addClass("d-none")
        let dataview = parseInt(pmid.target.attributes.getNamedItem('data-view').value);
        let datapipelineindex = pmid.target.attributes.getNamedItem('data-pipelineindex').value;
        setTimeout(
            () => {
                if(dataview===0){
                    pipeline_page_cnt = 100;
                    this.setState({page_selected_pipeline:datapipelineindex,enableFadeLoader:true})
                 }else{
                    this.setState({page_selected_pipeline:'',enableFadeLoader:true})
                 }
            },
            1000
        )
    }

    pagingreset(pm,pmid){
        pipeline_page_cnt = 50;
        if(parseInt(pmid.target.attributes.getNamedItem('data-view').value)===0){
            this.setState({page_selected_pipeline:pmid.target.attributes.getNamedItem('data-pipelineindex').value,enableFadeLoader:true})
         }else{
            this.setState({page_selected_pipeline:'',enableFadeLoader:true})
         }
    }

    gotoRuns(pmid,runid) {
        this.setState({more_job_runid:runid})
        $("#more_"+pmid).click();
    }

    getGanttPopover(jobid,pmstatus)
    {
        let tenantId = localStorage.getItem('team_id');
        let data = {
        "tenant_id":tenantId,
        "pipeline_job_id":jobid,
        "page":1,
        "filter_date":moment(this.state.endDate).format('YYYY-MM-DD').toString()
        }
        call_get_api(ui_service_ip,"/pipeline_run_info",data).then((response) => {
            if (response !== undefined && response.code === 200) {

                let pipeline_popover_content = document.getElementById("pipeline_popover_content")
                let pipeline_popover_title = document.getElementById("pipeline_popover_title")

                if(response.runs.length > 0){
                    let aresponse = response.runs;
                    for(let loop=0;loop<aresponse.length;loop++){
                        if(pipeline_popover_content){
ReactDOM.render(

    <div className="job-details">
    <p>
        <span><label>Run ID:</label><span style={{
            "color":"#5867dd",
            "text-decoration": "none",
            "background-color": "transparent",
            "cursor":"pointer"
        }} onClick={this.gotoRuns.bind(this,jobid,aresponse[loop])}>{aresponse[loop]["job_run_id"].slice(0, 10)}</span></span>
        <span className="job-details__action">
            {
                aresponse[loop]["run_status_text"] === "Failed" ?

            <span className="badge badge-light-danger mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" /></svg>
                {aresponse[loop]["run_status_text"]}
                                                    </span>
                                                    :
                                                    <span className="badge badge-light-success mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                                        {aresponse[loop]["run_status_text"]}
                                                    </span>
             }
            <span className="job-runtime">
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M15,1H9v2h6V1z M11,14h2V8h-2V14z M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42 C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M12,20c-3.87,0-7-3.13-7-7 s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20z" /></g></g></g></svg>
                {
                this.millisecondToMinutesAndSeconds(aresponse[loop]["duration"])
                }

                                                    </span>
        </span>
    </p>
    <p><span><label>Started:</label>{aresponse[loop]["run_started_time"]}</span></p>
    <p><span><label>End:</label>{response.runs[loop]["run_end_time"]}</span></p>
    <p><span style={{background: "none",color:"#5867dd",border: "none",padding: "0",font: "inherit",cursor: "pointer",textDecoration: "underline"}} onClick={this.setFullScreen.bind(this, pmstatus.pipelinesourcename, pmstatus.pipeline_job_id,this.state.pipelinesource_data[0].full_format_jobs_result,pmstatus)}>More</span></p>
    </div>,
    document.getElementById("pipeline_popover_content"))
}
}
if(pipeline_popover_title){

    ReactDOM.render(
        pmstatus.job_name , document.getElementById("pipeline_popover_title"))
    }
                }
                else {

                    if(pipeline_popover_content){
                    ReactDOM.render(
                        pmstatus.job_name , document.getElementById("pipeline_popover_content"))
                    }
                        if(pipeline_popover_title){
                    ReactDOM.render(
                        <span>
                            No Runs Found
                        </span> , document.getElementById("pipeline_popover_title"))
                        }
                }
            }
        })



        setTimeout(
            () => {
                ReactDOM.render(
                    <div className="job-details">
                    <p>
                        <span><label>Run ID:</label>Loading..</span>
                        <span className="job-details__action">
                            {/* <span className="badge badge-light-danger mr-2">
                                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                                                        Failed
                                                                    </span> */}
                            <span className="job-runtime">
                                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M15,1H9v2h6V1z M11,14h2V8h-2V14z M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42 C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M12,20c-3.87,0-7-3.13-7-7 s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20z" /></g></g></g></svg>
                                                                        Loading..
                                                                    </span>
                        </span>
                    </p>
                    <p><span><label>Started:</label>Loading..</span></p>
                    <p><span><label>End:</label>Loading..</span></p>
                    {/* <p><span><label>Troubleshooting and Diagnosis:</label><span >Check here</span></span></p> */}
                </div> , document.getElementById("pipeline_popover_content"))
        ReactDOM.render(
            <span>
            </span> , document.getElementById("pipeline_popover_title"))

            },
            5
        );
    }

    searchResult(searchText, originalData){
        if(searchText.length > 0){
            this.setState({searchText:searchText,enableFadeLoader:true})
        }
        else{
            this.setState({searchText:"",enableFadeLoader:true})
        }
    }

    render() {
        let tableData = '';
        // let datajson = {"code":200,"lineage_data":{"datasets":{"dataset_consumes_1":[{"dataset_uri":"s3://consuming_1_task/dataset_other.txt","dependant_dags":[],"lineage_dataset_id":15,"lineage_dataset_name":"dataset_other.txt"}],"dataset_consumes_1_and_2":[{"dataset_uri":"s3://consuming_2_task/dataset_other_unknown.txt","dependant_dags":[],"lineage_dataset_id":11,"lineage_dataset_name":"dataset_other_unknown.txt"}],"dataset_consumes_1_never_scheduled":[{"dataset_uri":"s3://consuming_2_task/dataset_other_unknown.txt","dependant_dags":[],"lineage_dataset_id":11,"lineage_dataset_name":"dataset_other_unknown.txt"}],"dataset_consumes_unknown_never_scheduled":[{"dataset_uri":"s3://unrelated_task/dataset_other_unknown.txt","dependant_dags":[],"lineage_dataset_id":12,"lineage_dataset_name":"dataset_other_unknown.txt"}],"dataset_produces_1":[{"dataset_uri":"s3://dag1/output_1.txt","dependant_dags":[{"dag_id":"dataset_consumes_1_never_scheduled"},{"dag_id":"dataset_consumes_1"},{"dag_id":"dataset_consumes_1_and_2"}],"lineage_dataset_id":14,"lineage_dataset_name":"output_1.txt"}],"dataset_produces_2":[{"dataset_uri":"s3://dag2/output_1.txt","dependant_dags":[],"lineage_dataset_id":13,"lineage_dataset_name":"output_1.txt"}]},"links":[{"destination":"dataset_consumes_1","source":"dataset_produces_1"},{"destination":"dataset_consumes_1_never_scheduled","source":"dataset_consumes_1_and_2"},{"destination":"dataset_consumes_1_and_2","source":"dataset_produces_2"},{"destination":"dataset_consumes_1_never_scheduled","source":"dataset_produces_1"},{"destination":"dataset_consumes_1_and_2","source":"dataset_produces_1"},{"destination":"dataset_produces_2","source":"dataset_produces_1"},{"destination":"dataset_consumes_unknown_never_scheduled","source":"dataset_consumes_1_never_scheduled"}],"pipeline_job_id":2933,"pipeline_job_name":"dataset_produces_2","tasks":{"dataset_consumes_1":[{"is_error":null,"task_id":434775,"task_name":"wait_for_dataset_1"},{"is_error":null,"task_id":434776,"task_name":"consuming_1"}],"dataset_consumes_1_and_2":[{"is_error":null,"task_id":434777,"task_name":"wait_for_dataset_1"},{"is_error":null,"task_id":434778,"task_name":"wait_for_dataset_2"},{"is_error":null,"task_id":434779,"task_name":"consuming_2"}],"dataset_consumes_1_never_scheduled":[{"is_error":null,"task_id":434780,"task_name":"wait_for_dataset_1"},{"is_error":null,"task_id":434781,"task_name":"wait_for_consumes_1_and_2"},{"is_error":null,"task_id":434782,"task_name":"consuming_3"}],"dataset_consumes_unknown_never_scheduled":[{"is_error":null,"task_id":434783,"task_name":"wait_for_consumes_1_never_scheduled"},{"is_error":null,"task_id":434784,"task_name":"unrelated_task"}],"dataset_produces_1":[{"is_error":null,"task_id":434751,"task_name":"producing_task_1"}],"dataset_produces_2":[{"is_error":null,"task_id":434773,"task_name":"wait_for_producing_task_1"},{"is_error":null,"task_id":434774,"task_name":"producing_task_2"}]}},"message":"Successfully fetched"}
        let pipelineSourceOption = [];
        if(this.state.pipelinesource_data !== "-1" &&  this.state.pipelinesource_data !== "No Integeration Found") {
            let ppl_source = this.pipelineSourceTableData(this.state.endDate);
            tableData = ppl_source[0];
        }
        pipelineSourceOption = this.state.pipeline_source_list;
        setTimeout(
            () => {
                $("#paging").val("20");
            },
            3000
        );
        let allvalues = JSON.parse(localStorage.getItem("piplineinitaldata"))
        return (
            <>
                {this.state.isInFullScreenMode === true & this.state.selectedJobRuns!==undefined ?
                    <PipelinePerformFullScreen
                        selectedJobDetails ={this.state.selectedJobDetails}
                        selectedPipelineInfo ={this.state.selectedPipelineInfo}
                        detailJobList={this.state.detailJobList}
                        closeFullScreenMode={this.closeFullScreenMode}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        ranges={this.state.ranges}
                        detailJobId={this.state.detailJobId}
                        detailPipelineName={this.state.detailPipelineName}
                        pipelinelist={allvalues}
                        filterpipelinelist={allvalues}
                        dataSourceOption={pipelineSourceOption}
                        pielinesourceID={this.state.page_selected_pipeline}
                        pipelinesource_data={this.state.pipelinesource_data}
                        tableData={this.state.tableData}
                        selectedJobRuns={this.state.selectedJobRuns}
                        more_job_runid={this.state.more_job_runid}
                        resetRunView={this.resetRunView}
                        pipeline_lastProfiling_fullscreen={this.state.latest_job_run_time}
                        monitor_pipeline_list = {this.state.monitor_pipeline_list}
                        pipeline_created_time = {this.state.pipeline_created_time}
                        pipeline_initialendDate = {this.state.pipeline_initialendDate}
                    /> : ""
                }
                {
                    tableData !== null ?
                   <>

{/* <PipelineLineage
                                                                        height="calc(100vh - 78px)"
                                                                        chart_id="linenage123"
                                                                        selectedNode = {"dataset_consumes_1"}
                                                                        data={datajson.lineage_data}
                                                                        /> */}

                        <div className="portlet-body pb-0">
                            <div className="qd-tab__content-action">
                                <div className="caption">
                                    <div className="alert moniker-alert" role="alert">
                                        <p className="mb-0">
                                <strong> {this.state.latest_job_run_time === false || this.state.latest_job_run_time === null || this.state.latest_job_run_time === undefined ? "--" : `Your last job ran at ${this.state.latest_job_run_time}`}</strong>
                                        </p>
                                    </div>
                                </div>

                    <div className="actions flex-shrink-0">
                    <button onClick={this.toggleFilter} className="btn btn-light">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#484848" height="24" className="mr-1"
                            viewBox="0 0 24 24" width="24">
                            <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                            <path d="M0 0h24v24H0z" fill="none" />
                        </svg>
                        <span className="dot-symbol"></span>
                        <span>Filters</span>
                    </button>
                </div>
            </div>
            <>
                {this.state.isFilterMode ?
                <div className="qd-filter-section">
                <div className="qd-filter__content">
                    <div className="qd-filter__header">
                        <h5 className="qd-filter__title">Data Relationship Filter</h5>
                        <button type='button' className="close"><span className="sr-only">Close</span></button>
                    </div>
                    <div className="qd-filter__body">
                        <div className="qd-filter__options">
                            <div className={"textfield-outlined"}>
                                <Form.Label>Pipeline Source</Form.Label>
                                <Select
                                        name="datasource"
                                        filterOption={({ label }, query) => label.includes(query)}
                                        defaultValue={this.state.selectedDatasource}
                                        id="choosePipelinesource"
                                        options={pipelineSourceOption}
                                        onChange={this.changePipelineSource}
                                        value={this.state.selectedDatasource}
                                        classNamePrefix='form-control'
                                        placeholder="Choose Pipeline Source"
                                        components={{ Control: customSelectDatasource }}
                                    />
                            </div>
                            <span className="dot-separator"></span>
                            {this.state.pipeline_created_time !==undefined  ?
                            <DateRangePicker dateLimit={{ days: 60 }}  containerClass="btn btn-datapicker reportrange"
                                                                        minDate={moment(this.state.pipeline_created_time)}
                                                                        maxDate={moment(this.state.initialendDate)}
                                                                        singleDatePicker={true}
                                                                        showDropdowns={true}
                                                                        startDate={this.state.endDate}
                                                                        onApply={this.handlePipelineListViewTimeFilter}
                                >
                                <i>
                                    <FontAwesomeIcon icon={faCalendar} />
                                </i>
                                <span>
                                {this.state.endDate.format(DISPLAY_DATE_FORMAT)}
                                </span>
                                <i className="icon-close ml-2"></i>
                            </DateRangePicker>
                            :""}
                            <span className="line-separator"></span>
                                <button className="btn btn-filter-reset shadow-none px-2" onClick={this.handleClearAll}>Clear All</button>
                        </div>
                    </div>
                </div>
                </div>
                : "" }
                                <div className="portlet">
                                    <div className="portlet-title">
                                        <div className="caption">
                                            <span className="text-uppercase font-dark">Pipeline Performance</span>
                                        </div>
                                    </div>
                            <div className="portlet-body pb-0">
                            {
                                this.state.errorMessage ? (
                                    <div className="row">
                                        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                                            <div className="placeholder-msg">
                                                <div className="placeholder-msg__icon">
                                                    <Image src="icon_placeholder_pipeline_configure" />
                                                </div>
                                                <div className="placeholder-msg__text">
                                                    <p>{this.state.errorMessage}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : tableData !== "" && this.state.api_call_loader === 0 ? (
                            <QualdoDataTable
                            sizePerPage={6}
                            applyTablewrapperClasses = {this.applyTablewrapperClasses}
                            initialendDate={this.state.initialendDate}
                            pipelinesourceFilterSelection={this.pipelinesourceFilterSelection}
                            id="monitorPipelineListView"
                            data={tableData}
                            paginationcurpage={this.state.paginationtrack}
                            lastSechduleDate= {this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)}
                            timefilter={this.state.timefilter}
                            applyTimeFilter={this.applyTimeFilter}
                            timeFilterActive={this.state.timefilter}
                            component_name="pipelineListViewTable"
                            renderPipelineSourceHtml = {this.renderPipelineSourceHtml}
                            renderJobsSourceHtml = {this.renderJobsSourceHtml}
                            activeRun = {this.activeRun}
                            showGraph= {this.showGraph}
                            statusIcon= {this.statusIcon}
                            setFullScreen = {this.setFullScreen}
                            handlePipelineTreeTriger = {this.handlePipelineTreeTriger}
                            errMessage = {this.errMessage}
                            page_selected_pipeline = {this.state.page_selected_pipeline}
                            pipelinesource_filter={this.state.pipelinesource_filter}
                            pageTrack={this.pageTrack}    
                            prevDate={this.prevDate}
                            nextDate={this.nextDate}
                            nowDate={this.nowDate}
                            searchResult={this.searchResult}
                        />)
                        :
                        this.state.pipelinesource_data === "No Integeration Found"  || this.state.pipelinesource_data === "-1" ?
                          <div className="row">
                        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                            <div className="placeholder-msg">
                                <div className="placeholder-msg__icon">
                                    <Image src="icon_placeholder_pipeline_configure" />
                                </div>
                                <div className="placeholder-msg__text">
                                    <h6>No Pipeline Sources</h6>
                                    <p>No Pipeline source connector configured</p>
                                </div>
                                <div className="placeholder-msg__action">
                                    <button onClick={this.gotoPipelineConfigure} className="btn btn-outline btn-grey btn-circle"><i><FontAwesomeIcon icon={faPlusCircle} /></i>Add Pipelines Source</button>
                                </div>
                            </div>
                        </div>
                    </div> : <Load/>
                            }

                                    </div>
                                </div>
                            </>


                        </div>
                        </>
                        : <Load />
                }
                <div className="row d-none">
                    <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div className="placeholder-msg">
                            <div className="placeholder-msg__icon">
                                <Image src="icon_placeholder_pipeline_configure" />
                            </div>
                            <div className="placeholder-msg__text">
                                <h6>No Pipeline Sources</h6>
                                <p>No Pipeline source connector configured</p>
                            </div>
                            <div className="placeholder-msg__action">
                                <button onClick={this.gotoPipelineConfigure} className="btn btn-outline btn-grey btn-circle"><i><FontAwesomeIcon icon={faPlusCircle} /></i>Add Pipelines Source</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row d-none">
                    <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div className="placeholder-msg">
                            <div className="placeholder-msg__icon">
                                <Image src="icon_placeholder_no_pipeline_data" />
                            </div>
                            <div className="placeholder-msg__text">
                                <h6>No data available for the chosen date</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
const mapStateToProps = state => {
    return state;
}
export default connect(mapStateToProps)(PipelineListViewContent);